<template>
	<div>
<!--		<breadcrumb :routerList="[{to:'/basic/user',title:'系统管理'},{title:'资源管理'}]"/>-->
    <Breadtabsheader/>
		<div class="h-content">
			<div class="h-row">
				<div class="h-rowIn" style="width: 45%;height: 7.73rem;">
					<div class="h-rowBox" style="height: 7.73rem;">
						<div class="h-rowTitle">
							<div class="h-disTable" style="display: flex;align-items: center;justify-content: space-between;">
								<div class="h-tableCell">
									<h1>系统资源</h1>
								</div>
								<el-button class="h-btn h-formBtn h-bgblueQ2" @click="addTopUrl">添加根节点</el-button>
							</div>
						</div>
						<div class="h-rowCon" style="overflow: auto;height: 6rem;">
							<vtree :data="treedata"
								   ref="tree1"
								   @item-click="itemClick"
								    >
								<template scope="_">
									<div style="display: inherit">
										<i :class="_.vm.themeIconClasses" role="presentation" v-if="!_.model.loading"></i>
										<span :style="[_.model.delflag==0?{ textDecoration: 'line-through'}:'']">{{_.model.name}}</span>
										<button style="border: 0px; padding: 0 3px;background-color: transparent; cursor: pointer;" @click="customItemClick(_.vm, _.model, $event,1)"><i class="el-icon-circle-plus"></i></button>
										<button style="border: 0px; padding: 0 3px;background-color: transparent; cursor: pointer;" @click="customItemClick(_.vm, _.model, $event,2)"><i class="el-icon-edit"></i></button>
										<button style="border: 0px; background-color: transparent; cursor: pointer;" @click="customItemClick(_.vm, _.model, $event,3)"><i class="el-icon-delete"></i></button>
									</div>
								</template>
							</vtree>
						</div>
					</div>
				</div>
				<div class="h-rowIn" style="width: 55%;">
					<div class="h-rowBox">
						<div class="h-rowTitle">
							<div class="h-disTable">
								<div class="h-tableCell">
									<h1>资源详情</h1>
								</div>
							</div>
						</div>
						<div class="h-rowCon">
							<el-form 
								ref="form" 
								:model="f"
								:inline="true"  
								class="demo-ruleForm h-formbLine h-dialogForm" style="padding: 0.2rem 0.2rem 0.1rem 0.2rem;">
								<el-form-item label="主键" prop="id"  class="h-elformWrap-1">
									<el-input readonly v-model="f.id"></el-input>
								</el-form-item>
								<el-form-item label="父节点id"  prop="pid"  class="h-elformWrap-2">
									<el-input readonly v-model="f.pid"></el-input>
								</el-form-item>
								<el-form-item label="父节点名称" v-show="pidName != null" class="h-elformWrap-2">
									<el-input readonly v-model="pidName"></el-input>
								</el-form-item>
								<el-form-item 
								label="编码" 
								prop="code" 
								:rules="[{ 
									required: true, 
									message: '请输入编码名称', 
									trigger: 'blur'},]" 
									class="h-elformWrap-1">
									<el-input v-model="f.code"></el-input>
								</el-form-item>
								<el-form-item 
								label="名称" 
								prop="name" 
								:rules="[{ 
									required: true, 
									message: '请输入名称名称', 
									trigger: 'blur'},]" 
									class="h-elformWrap-1">
									<el-input v-model="f.name"></el-input>
								</el-form-item>
								<el-form-item 
								label="url链接" 
								prop="url" 
								:rules="[{ 
									required: true, 
									message: '请输入url链接名称', 
									trigger: 'blur'},]" 
									class="h-elformWrap-1"
									>
									<el-input v-model="f.url"></el-input>
								</el-form-item>
								<el-form-item 
									label="是否左侧菜单" 
									prop="showflag" 
									:rules="[{ 
										required: true, 
										message: '请输入是否展示名称', 
										trigger: 'blur'},]" 
										class="h-elformWrap-2"
									>
									<brselect 
										category="shifou_keyong" 
										:v="f.showflag" 
										v-model="f.showflag">
									</brselect>
								</el-form-item>
								<el-form-item 
									label="是否可用" 
									prop="delflag" 
									:rules="[{ 
									required: true,
									message: '请输入是否可用：1：可用，0：不可用名称',
									trigger: 'blur'},]" 
									class="h-elformWrap-2"
									>
									<brselect category="shifou_keyong" :v="f.delflag" v-model="f.delflag"></brselect>
								</el-form-item>
								<el-form-item 
									label="排序" 
									prop="orderby" 
									:rules="[{ required: true, message: '请输入排序名称', trigger: 'blur'},
									{ type: 'number', message: '必须为数字值'}]" 
									class="h-elformWrap-1"
									>
									<el-input v-model.number="f.orderby"></el-input>
								</el-form-item>
								<el-form-item label="扩展样式" prop="ext"   class="h-elformWrap-1">
									<el-input v-model="f.ext"></el-input>
								</el-form-item>
								<el-form-item 
									label="描述" 
									prop="des" 
									:rules="[{ required: true, message: '请输入描述名称', trigger: 'blur'},]" 
									class="h-elformWrap-1">
									<el-input v-model="f.des"></el-input>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" v-show="optflag != 'detail'" @click="submitForm">{{btnname}}</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
    import ss from '../../api/SystemService'
	import _ from 'loadsh'
    export default {
        	components: {},
			data() {
				return {
					//表单
					f:{
						id:null,
						pid:null,
						code:null,
						name:null,
						url:null,
						showflag:null,
						orderby:null,
						ext:null,
						delflag:null,
						des:null,
					},
					//table列表
					treedata: [],
					pidName:null,
					//操作标志
					optflag:'detail',
					btnname:'新建',
				nowitem:null,
				}
			},
			created() {
					this.loadtree();
			},
        	methods: {
            loadtree(p) {
				ss.ResourceService.resList().then(rd=>{
				    this.treedata = rd;
				})
            },
            customItemClick(node, item, e,t){
                this.nowitem = item;
                e.stopPropagation()
				//增加，
				if(t==1) {
					this.$refs['form'].resetFields();
					this.f.children = null;
					this.optflag = 'add'
					this.btnname = '提交新建'
					this.f.pid = item.id
					this.pidName = item.name
				//    修改
            }else if(t == 2){
					this.f = _.clone(item);
					this.f.children = null;
					this.optflag = 'update'
					this.btnname = '提交修改'
				//    删除
				}else if(t==3){
				    if(item.children && item.children.length > 0){
						this.$msg.msge("有子菜单不允许删除")
						return;
					}
				   this.$msg.confirm("确认删除？",()=>{
						ss.ResourceService.deleteById(item.id).then(rd=>{
							this.$msg.msgs("操作成功！")
							this.loadtree();
						})
					})
				}
			},
			itemClick (node, item, e) {
				this.f = _.clone(item);
				this.optflag = 'detail'
			},
			handleFilter() {
				this.query();
			},
			addTopUrl(){
				this.optflag = 'add'
				this.btnname = '提交新建'
				this.pidName = null
				this.$refs['form'].resetFields();
			},
			submitForm(){
				if(this.optflag == 'add'){
					ss.ResourceService.insert(this.f).then(rd=>{
						this.loadtree();
						this.$msg.msgs("操作成功！")
					})
				}else if(this.optflag == 'update'){
					this.$msg.confirm("确认修改？",()=>{
						ss.ResourceService.updateById(this.f).then(rd=>{
								this.$msg.msgs("操作成功！")
						})
					})
				}
			},
      }
   }
</script>
